import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EfOurAwards from 'elem/ui/ef-our-awards';
import EfOurPartners from 'elem/ui/ef-our-partners';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    const subs = [
        {
            title: t('J_sub1_title'),
            desc: t('J_sub1_desc'),
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
                    <g clipPath="url(#clip0_58_11413)">
                        <path
                            d="M27.8789 55.3589C27.8789 55.3589 29.9928 47.4879 32.1147 46.6758C34.7033 45.6915 40.9119 43.4963 40.9119 43.4963C41.4031 43.3339 41.7813 38.9435 41.7813 38.9435C40.5288 37.7426 38.4854 35.7542 37.9942 33.0766C35.219 32.5845 33.4999 27.6626 36.0295 27.5149C34.2465 21.6086 37.8616 15.8697 41.7273 15.3824C41.128 13.4137 41.354 10.8789 45.3031 10.8789C49.1295 10.8789 49.1295 13.9895 48.5744 15.3086C53.1327 15.2742 56.3008 21.7464 54.2084 27.4903C56.7036 27.3033 55.4412 31.9495 53.0737 32.8256C52.7446 35.7788 50.2003 38.156 48.5695 38.9189C48.5695 38.9189 48.9232 43.3043 49.4389 43.4717C49.4389 43.4717 56.5268 45.3174 58.9336 46.6512C61.5222 48.0884 63.0792 51.8143 63.0792 51.8143"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M35.0033 45.6385C33.2025 44.7902 25.7607 42.8074 25.7607 42.8074C24.8156 42.6541 24.8405 39.3886 24.8554 38.2388C27.7505 36.6035 29.0887 32.2903 28.9494 30.7317C31.2973 29.7096 32.8444 24.9825 29.5712 25.3249C31.944 23.4545 32.0087 10.3363 23.2486 9.17624C14.7522 8.05707 16.1003 11.6599 15.1054 11.7723C10.5886 12.3395 7.83772 17.8485 11.2204 25.3147C7.73823 24.3897 9.80264 30.3126 11.5885 31.1763C11.4641 33.6395 14.0409 36.7976 15.8018 38.2285C15.7571 39.3886 15.9063 42.3628 14.9015 42.7972C14.9015 42.7972 7.17114 44.6727 5.11668 46.0218C3.87804 46.8395 2.91797 51.5461 2.91797 51.5461C16.9553 57.9677 45.03 57.2486 63.078 51.8409"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_58_11413">
                            <rect width="64" height="64" fill="white" transform="translate(0.5 0.195312)" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            title: t('J_sub2_title'),
            desc: t('J_sub2_desc'),
            icon: (
                <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_58_11425)">
                        <path
                            d="M33.0016 54.3977C45.3728 54.3977 55.4016 44.3689 55.4016 31.9977C55.4016 19.6264 45.3728 9.59766 33.0016 9.59766C20.6303 9.59766 10.6016 19.6264 10.6016 31.9977C10.6016 44.3689 20.6303 54.3977 33.0016 54.3977Z"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.3984 35.1984C14.1251 36.3413 16.982 39.1661 18.181 38.0232C19.9794 36.309 18.4275 31.1063 20.9463 29.6715C23.465 28.2366 27.3025 34.597 30.8893 32.5042C34.4759 30.4113 30.5513 24.8308 33.0404 22.5684C35.5294 20.3061 38.7661 22.8576 39.3318 19.0747C39.8976 15.2919 36.8135 13.9732 36.1984 10.3984"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinecap="round"
                        />
                        <path
                            d="M34.5993 53.6C33.1879 52.3107 32.6798 51.1123 33.075 50.0047C33.6678 48.3432 38.1555 48.8309 39.3984 47.2C40.6414 45.5691 40.9984 44 43.3984 44C45.7984 44 48.1984 45.6 48.9991 46.3881"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinecap="round"
                        />
                        <path
                            d="M52.313 20.7969C58.3199 21.2907 62.4422 23.0265 63.2561 25.8878C64.8841 31.611 52.6585 39.6694 35.9494 43.8866C19.2403 48.1038 4.37508 46.8829 2.74702 41.1597C1.89403 38.1611 4.8439 34.5215 10.249 31.1293"
                            stroke="black"
                            strokeWidth="1.92"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_58_11425">
                            <rect width="64" height="64" fill="white" transform="translate(0.5 0.195312)" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            title: t('J_sub3_title'),
            desc: t('J_sub3_desc'),
            icon: (
                <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M25.2999 13.4023L27.4012 14.9352L30.0021 14.9302L30.8012 17.4054L32.9083 18.9302L32.0999 21.4023L32.9083 23.8745L30.8012 25.3993L30.0021 27.8745L27.4012 27.8695L25.2999 29.4023L23.1985 27.8695L20.5976 27.8745L19.7985 25.3993L17.6914 23.8745L18.4999 21.4023L17.6914 18.9302L19.7985 17.4054L20.5976 14.9302L23.1985 14.9352L25.2999 13.4023Z"
                        stroke="black"
                        strokeWidth="1.92"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.3178 25.0511L16.0056 30.7881L14.8999 32.7031L17.1112 32.713L18.1248 32.7175L18.6354 33.593L19.7496 35.5031L20.8553 33.5881L23.873 28.3613L23.1985 27.8693L21.9386 27.8717L19.7411 31.6779L19.2305 30.8024L18.2169 30.7979L20.3492 27.1047L19.7985 25.399L19.3178 25.0511ZM26.7609 28.3364L29.7929 33.5881L30.8986 35.5031L32.0128 33.593L32.5235 32.7175L33.537 32.713L35.7483 32.7031L34.6427 30.7881L31.3161 25.0264L30.8012 25.399L30.2679 27.0508L32.4313 30.7979L31.4178 30.8024L30.9071 31.6779L28.7096 27.8718L27.4012 27.8693L26.7609 28.3364Z"
                        fill="black"
                    />
                    <rect x="10.6592" y="5.96" width="44.48" height="52.48" rx="3.04" stroke="black" strokeWidth="1.92" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M38.7666 43.8351H27.7031V42.2031H38.7666V43.8351ZM38.7505 47.9133H27.7031V46.2812H38.7505V47.9133ZM38.7505 51.9953V50.3633H27.7031V51.9953H38.7505Z"
                        fill="black"
                    />
                    <rect x="40.1992" y="42.2031" width="10.8664" height="1.54653" fill="black" />
                    <path d="M51.0656 47.954H41.7519V49.9777V51.9987H40.1992V47.954V46.3281H51.0656V47.954Z" fill="black" />
                    <circle cx="25.2992" cy="21.4047" r="2.8" stroke="black" strokeWidth="1.6" />
                </svg>
            ),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <div className="info">
                <p className="title">{t('J_title')}</p>
                <p className="desc">{t('J_desc')}</p>
            </div>
            <div className="img-box">
                <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726107321252/Group%20(1).png" h5="" />
                <ul className="subs">
                    {subs?.map((sub: any, k: number) => (
                        <li className="sub" key={k}>
                            <div className="sub-icon">{sub.icon}</div>
                            <p className="sub-title">{sub.title}</p>
                            <p className="sub-desc">{sub.desc}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <EfOurAwards title={t('J_list1_title')} />
            <EfOurPartners title={t('J_list2_title')} />
        </div>
    );
}
